// extracted by mini-css-extract-plugin
export var chatHtmlText = "_o5-2";
export var chatLink = "_o5-0";
export var chatText = "_o5-1";